import axios from 'axios';
import { toast } from 'sonner';

const API = axios.create({
	baseURL: process.env.REACT_APP_BASE_API,
});

API.withCredentials = true;

API.interceptors.request.use(
	function (config) {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	null,
	{},
);

API.interceptors.response.use(
	(response) => {
		const status = response?.data?.status;

		if (status === 401) {
			handleSessionExpiry('Unauthorized access. Please log in again.');
		} else if (status === 403) {
			handleAccessDenied('Access denied.');
		}

		return response;
	},
	(error) => {
		const status = error?.response?.status;
		if (status === 401) {
			handleSessionExpiry('Unauthorized access. Please log in.');
		} else if (status === 403) {
			handleAccessDenied('Access denied. Your account is inactive.');
		}

		return Promise.reject(error);
	},
);

let isLoggedOut = false;

const handleSessionExpiry = (message) => {
	if (!isLoggedOut) {
		isLoggedOut = true;
		toast.error(message);
		localStorage.clear();
		setTimeout(() => {
			window.location.href = '/login';
		}, 1000);
	}
};

const handleAccessDenied = (message) => {
	// toast.error(message);
	setTimeout(() => {
		window.location.href = '/';
	}, 1000);
};

export default API;
